import { stat } from "fs"

export interface LabelType {
  es: Record<string, string>
  en: Record<string, string>
  pt: Record<string, string>
}

export const labels: LabelType = {
  es: {
    // STORES
    stores: 'Almacenes',
    bookings: 'Citas',
    booking: 'Cita',
    companies: 'Compañias',
    company: 'Compañia',
    store: 'Almacén',
    selectDate: 'Selecciona una fecha',
    addStore: 'Añadir Almacén',
    companyDeleted: 'Almacén eliminado',
    companyCreated: 'Almacén creado',
    companyUpdated: 'Almacén actualizado',
    addCompany: 'Añadir Compañia',
    storeDeleted: 'Almacén eliminado',
    storeCreated: 'Almacén creado',
    storeUpdated: 'Almacén actualizado',
    mainCashier: 'Cajera principal',
    addBooking: 'Añadir Cita',
    editBooking: 'Modificar cita',
    addBookings: 'Añadir Citas',
    addBookingInterStores: 'Añadir cita entre almacenes',
    searchBookings: 'Buscar Citas',
    bookingDeleted: 'Cita eliminada',
    bookingCancelledCantSign: 'Esta cita está anulada y no se puede firmar',
    bookingCreated: 'Cita creada',
    bookingUpdated: 'Cita actualizada',
    slotTaken: 'La franja seleccionada acaba de ser ocupada. Elige otra.',
    slotNotFound: 'La franja seleccionada ya no está disponible en el calendario. Recarga y elige otra.',
    bookingCreatedPendingAuth: 'Cita creada. Pendiente de autorización del responsable.',
    reason: 'Motivo',
    medicalHistory: 'Historial médico',
    notes: 'Notas',
    patient: 'Paciente',
    cif: 'CIF',
    positionJob: 'Puesto',
    positionJobLow: 'puesto',
    positionJobs: 'Puestos',
    physios: 'Fisios',
    locations: 'Ubicaciones',
    storeName: 'Nombre de Almacén',
    storeUsers: 'Usuarios Almacén',
    searchStore: 'Buscar almacenes',
    role: 'Rol',
    lastname: '1º Apellido',
    lastname2: '2º Apellido',
    lastnames: 'Apellidos',
    userResponsable: 'Usuario Responsable',
    noOptions: 'No hay acciones disponibles',
    product: 'Producto',
    workWindow: 'Turno',
    when: '¿Cuando ocurrió?',
    where: '¿Donde ocurrió?',
    category: 'Categoria',
    signed: 'Conforme',
    sinthomesRelated: 'Zona afectada',
    whoParticipatedAnalyse: 'Participan en el analisis',
    testigos: 'Testigos',
    comunPatology: 'Patología Común',
    bookingReason: 'Motivo de Cita',
    campaignId: 'Id Campaña',
    campaignName: 'Nombre Campaña',
    bookingDetail: 'Detalle cita',
    createdBy: 'Agendado por',
    userDetail: 'Detalle Usuario',
    incidentDetail: 'Detalle Incidencia',
    campaignDetail: 'Detalle Campaña',
    incidentId: 'Id Incidente',
    bookingId: 'Id Cita',
    sign: 'Firmar',
    daysSinceDayOff: 'Dias desde última libranza',
    injuredWorker: 'Trabajador lesionado',
    availabilityUpdated: 'Disponibilidad actualizada',
    filterByRole: 'Filtrar por puesto',
    filterByCompany: 'Filtrar por compañia',
    filterByStore: 'Filtrar por almacén',
    // OLDER
    login: 'Iniciar Sesión',
    loginTitle: 'Acceso Metaphysio',
    welcomeTitle1: 'Impulsando el futuro de la',
    welcomeTitle2: 'salud laboral',
    welcomeSubtitle: 'Herramienta de gestión de fisioterapia para empresas',
    welcomePill1: 'Gestión de citas',
    welcomePill2: 'Empleados',
    welcomePill3: 'Prevención laboral',
    welcomePill4: 'Productividad',
    password: 'Contraseña',
    passwordChanged: 'La contraseña ha sido actualizada correctamente',
    passwordChangingError: 'Ha ocurrido un problema al intentar actualizar la contraseña, por favor intentelo mas tarde.',
    incorrectPassword: 'La contraseña actual introducida es incorrecta',
    newPassword: 'Nueva contraseña',
    repeatNewPassword: 'Repite tu nueva contraseña',
    maintainSession: 'Mantener sesión iniciada',
    forgotPass: 'He olvidado mi contraseña',
    newEmail: 'Nuevo email',
    changeEmail: 'Cambiar email',
    emailInUse: 'Este email ya esta en uso',
    weSendEmail: 'Te hemos enviado un email',
    weSendEmail2: 'Hemos enviado un enlace a tu nuevo email para verificar tu cuenta.',
    recoverYourPassword:
      'Consulta tu bandeja de entrada para restablecer tu contraseña. Es posible que tengas que comprobar la carpeta de correo no deseado.',
    errorWhenSendingEmail1: 'Error en el envío de email',
    errorWhenSendingEmail2: 'Ha ocurrido un error al enviar el email de restaurar contraseña, por favor intentelo de nuevo mas tarde.',
    search: 'Buscar',
    area: 'Area',
    update: 'Actualizar',
    edit: 'Modificar',
    add: 'Añadir',
    accept: 'Aceptar',
    downloadQr: 'Descargar QR',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    cancelled: 'Cancelado',
    cancelledBy: 'Cancelado por',
    name: 'Nombre',
    email: 'Email',
    nameSurname: 'Nombre y apellidos',
    information: 'Información',
    payments: 'Pagos',
    state: 'Estado',
    address: 'Dirección',
    phone: 'Teléfono',
    message: 'Mensaje',
    age: 'Edad',
    description: 'Descripción',
    contactPerson: 'Persona de contacto',
    beneficiaryName: 'Nombre del beneficiario',
    optional: 'Opcional',
    nationalId: 'NIF/CIF',
    quantity: 'Cantidad',
    quality: 'Calidad',
    likes: 'Favoritos',
    summary: 'Resumen',
    general: 'General',
    city: 'Ciudad',
    registerDate: 'Fecha de registro',
    contact: 'Contacto',
    export: 'Exportar',
    deselectAll: 'Deseleccionar todos',
    selectAll: 'Seleccionar todos',
    selected: 'Seleccionado',
    selecteds: 'Seleccionados',
    deactivated: 'Desactivado',
    deactivate: 'Desactivar',
    deactivateAll: 'Modificar estado',
    activate: 'Activar',
    activated: 'Activado',
    value: 'Valor',
    history: 'Historial',
    hour: 'hora',
    minutes: 'minutos',
    min: 'min',
    ayuda: 'Help',
    faq: 'Preguntas frecuentes',
    horarios: 'Horarios',
    helpCenter: 'Centro de ayuda',
    someIncorrectData: '¿Algún dato incorrecto?',
    instagram: 'Instagram',
    deleted: 'Eliminado',
    recoverPassword: 'Recuperar contraseña',
    recoverPasswordText: 'Te enviaremos un correo electrónico para que actualices tu contraseña',
    emailError: 'Introduce un correo electrónico correcto',
    notifications: 'Notificaciones',
    settings: 'Ajustes',
    logout: 'Cerrar sesión',
    logoutText: 'Estás a punto de cerrar la sesión, ¿estás seguro?',
    next: 'Siguiente',
    return: 'Volver',
    save: 'Guardar',
    import: 'Importar',
    statusChanged: 'El estado ha sido cambiado',
    status: 'Estado',
    active: 'Activo',
    disabled: 'Inactivo',
    location: 'Localidad',
    only: 'Solo',
    noResults: 'No hay resultados',
    moreThanThreeCharacters: 'Empieza a escribir para ver resultados',
    continue: 'Continuar',
    percent: 'Porcentaje',
    csvImport: 'Importar CSV',
    importUsers: 'Importar usuarios',
    waiting: 'Esperando',
    changePassword: 'Cambiar contraseña',
    successDialogUpdatePassword: 'Contraseña cambiada con éxito',
    newOrdersCancelationsEmails: 'Emails sobre nuevos pedidos y cancelaciones',
    offersEmail: 'Emails con ofertas especiales y promociones',
    selectTime: 'Seleccionar hora',
    todayPlate: 'Plato de Hoy',
    date: 'Fecha',
    newDate: 'Nueva fecha',
    newHour: 'Nueva hora',
    exportData: 'Exportar Datos ↓',
    yourRestaurant: 'Tu restaurante',
    management: 'Gestión',
    expirationDate: 'Fecha de vencimiento',
    byDefault: '↪ Por defecto:',
    loadMore: 'Cargar más',
    noFilters: 'Sin filtros',
    complete: 'Firmar',
    completeBooking: 'Completar cita con firma paciente',
    askBooking: 'Solicitar Cita',
    timezone: 'Franja horaria',
    bookingCompleted: 'Asistencia confirmada',
    bookingCompletedError: 'Ha ocurrido un error al cerrar la cita',
    signedError: 'Ha ocurrido un error al guardar la firma',

    completed: 'Asiste',
    noAssist: 'No asiste',
    assist: 'Asistencia',
    pending: 'Pendiente',
    close: 'Cierre',
    closeReason: 'Motivo cierre de incidencia',
    closeDate: 'Fecha de cierre',
    incidentCloseOk: 'Investigación cerrada correctamente',
    sessions: 'Sesiones',

    // HELP
    help: 'Ayuda',
    helpEmail: 'Si necesitas asistencia, ponte en contacto con nosotros en ',
    helpInstagram: 'Síguenos en redes sociales y mantente al día de las novedades de Metaphysio.',
    helpPhone: 'Si necesitas asistencia, ponte en contacto directo con nosotros en el ',
    termsConditions: 'Aviso Legal',
    privacyPolicy: 'Política de privacidad',
    cookiesPolicy: 'Política de cookies',
    contactMetaphysio: 'Contactar con Metaphysio',
    contactMetaphysio2: 'Contacta con Metaphysio',
    metaphysioPolitic: 'Política de Metaphysio',
    query: 'Consulta',
    questionSended: 'Consulta enviada',
    send: 'Enviar',

    // ERRORS
    hasBeenAnError: 'Hubo un error, por favor prueba de nuevo más tarde',
    changeCompleted: 'Cambio completado con éxito',
    // USERS
    users: 'Usuarios',
    user: 'usuario',
    addUser: 'Añadir usuario',
    searchUser: ' Buscar usuario',
    userName: 'Nombre de usuario',
    userDeleted: 'El usuario ha sido borrado',
    userCreated: 'El usuario ha sido creado',
    userUpdated: 'El usuario ha sido actualizado',
    emailSent: 'Email enviado correctamente',
    emailSentDialogText1: 'Se ha enviado un email a ',
    emailSentDialogText2: 'con las instrucciones para validar su cuenta de usuario.',
    errorDialogUser: 'El email introducido ya está en uso. Contacta con el usuario para utilizar otro diferente.',
    preUser: 'Pre-Usuario',
    birthday: 'Fecha nacimiento',
    gender: 'Sexo',
    sector: 'Sector',
    position: 'Position',
    employeeId: 'Nº de Empleado(Ldap)',
    genderEditing: 'Elige el sexo del usuario',
    personalData: 'Datos Personales',
    workingSince: 'Fecha de antigüedad',
    comercialManager: 'Responsable comercial',
    cashier: 'Cajero/a',
    cashManager: 'Responsable de cajas',
    logisticManager: 'Responsable de logística',
    seller: 'Vendedor/a',
    whatHappened: '¿Qué ha pasado?',
    why: '¿Por qué?',
    how: '¿Como?',
    affectedZone: 'Zona Afectada',
    professionalChannel: 'Canal profesional',
    paymentMethods: 'Formas de pago',
    Man: 'Hombre',
    Woman: 'Mujer',
    file: 'Archivo',
    importSuccess: 'Importación realizada',
    importUsersTitle: 'Usuarios añadidos correctamente',
    importUsersText: 'Hemos enviado un email a los usuarios con las instrucciones para validar sus cuentas.',
    importUsersError: 'Uy, algo no funcionó',
    importUsersErrorText1: 'Los siguientes emails ya están en uso:',
    importUsersErrorText2: 'Contacta con estos usuarios para utilizar emails diferentes.',
    importUsersPrevalidation: 'Los campos "user", "surname" y "email" son obligatorios en todas las filas.',
    importFileSuccess: 'Archivo de importación correcto',
    confirmWithSign: 'Confirmar asistencia con firma',
    confirmWithSignIncident: 'Firmar parte de investigación',
    incidentSignedOk: 'Incidente firmado correctamente',
    incidentSigned: 'Firmado',
    incidentNotSigned: 'Faltan ambas',
    incidentNotSignedWorker: 'Falta Colaborador',
    incidentNotSignedResponsable: 'Falta Responsable',
    morning: 'Mañana',
    afternoon: 'Tarde',
    // WEEKDAYS
    today: 'Hoy',
    tomorrow: 'Mañana',
    Monday: 'Lunes',
    Tuesday: 'Martes',
    Wednesday: 'Miércoles',
    Thursday: 'Jueves',
    Friday: 'Viernes',
    Saturday: 'Sábado',
    Sunday: 'Domingo',
    // LOGIN ERRORS
    ERR_NO_EMAIL: 'El email introducido no pertenece a ninguna cuenta. Prueba con otro.',
    ERR_INVALID_EMAIL: 'El email introducido no es válido',
    ERR_WRONG_PASS: 'Contraseña incorrecta. Prueba de nuevo.',
    ERR_PASS_WRONG_TIMES: 'Contraseña incorrecta demasiadas veces. Prueba de nuevo en 5 minutos o pulsa "He olvidado mi contraseña',
    // ERR_PASS_REQUIREMENTS: 'La contraseña no cumple los requisitos requeridos, te hemos enviado un email para que puedas resetearla',
    ERR_PASS_REQUIREMENTS:
      'La contraseña no cumple los requisitos requeridos, pulsa en He olvidado mi contraseña para solicitar un correo para cambiarla.',
    // 404
    returnToList: 'Por favor, vuelve al listado y elige otro.',
    notFound: 'No hemos encontrado nada',
    // ERRORBOUNDARY
    boundaryTitle: 'Lo sentimos :( ha habido un error',
    errorEmailValidation: 'Debería ser un email válido',
    errorEmployeeIdValidation: 'El número de empleado esta repetido',
    // NAVIGATION
    machines: 'Máquinas',
    processes: 'Procesos',
    statitics: 'Estadísticas',
    calendars: 'Calendarios',
    calendar: 'Calendario',
    sectors: 'Sectores',
    areas: 'Areas',
    hierarchies: 'Jerarquías',
    // companies: 'Compañias',
    pathologies: 'Patologías',
    incidents: 'Incidentes',
    incident: 'Incidente',
    issues: 'Incidencias',
    searchIssues: 'Buscar incidencias',
    campaigns: 'Campañas',
    rrhh: 'RRHH',
    admin: 'Admin',
    utils: 'Utilidades',
    searchCompany: 'Buscar compañia',
    // Pathologies
    pathologiesDeleted: 'Patología borrada',
    searchPathologies: 'Buscar patología',
    addPathologies: 'Añadir patología',
    pathologyCreated: 'Patología creada',
    pathologyUpdated: 'Patología actualizada',
    pathology: 'Patología',
    // Machines
    machinesDeleted: 'Máquina borrada',
    searchMachines: 'Buscar máquina',
    searchRoles: 'Buscar puesto',
    addMachines: 'Añadir máquina',
    machinesCreated: 'Máquina creada',
    machinesUpdated: 'Máquina actualizada',
    machine: 'Máquina',
    // Incident
    incidentDeleted: 'Incidente borrada',
    searchIncident: 'Buscar incidente',
    addIncident: 'Añadir incidente',
    editIncident: 'Editar incidente',
    editedBy: 'Editado por',
    incidentCreated: 'Incidente creado',
    incidentUpdated: 'Incidente actualizado',
    incidentResearch: 'Añadir Investigación de incidente',
    open: 'Abierta',
    alta: 'Alta',
    noResolution: 'Sin resolución',
    full: 'Máximo de sesiones',
    statusIncident: 'Estado Investigación',
    // Sectors
    sectorsDeleted: 'Sector borrado',
    rolesDeleted: 'Puesto borrado',
    searchSectors: 'Buscar sector',
    addSectors: 'Añadir sector',
    sectorsCreated: 'Sector creado',
    sectorsUpdated: 'Sector actualizado',
    // Areas
    areasDeleted: 'Area borrada',
    searchAreas: 'Buscar area',
    addAreas: 'Añadir area',
    areasCreated: 'Area creada',
    areasUpdated: 'Area actualizada',
    // Processes
    processesDeleted: 'Proceso borrado',
    searchProcesses: 'Buscar proceso',
    addProcesses: 'Añadir proceso',
    processesCreated: 'Proceso creado',
    processesUpdated: 'Proceso actualizado',
    process: 'Proceso',
    // Campaigns
    campaignsDeleted: 'Campaña borrada',
    searchCampaigns: 'Buscar campaña',
    addCampaigns: 'Añadir campaña',
    editCampaign: 'Editar campaña',
    campaignsCreated: 'Campaña creada',
    campaignsUpdated: 'Campaña actualizada',
    incorcamp: 'Incidencia/Campaña/PC',
    campaign: 'Campaña',
    // ROLES
    roles: 'Roles',
    addRoles: 'Añadir roles',
    addPositions: 'Añadir puestos',
    rolesUpdated: 'Rol actualizado',
    rolesCreated: 'Rol creado',
    hr: 'RRHH',
    physio: 'Fisioterapeuta',
    worker: 'Colaborador',
    storeManager: 'Jefe de almacén',
    director: 'role4',
    departmentManager: 'Jefe de sector',
    January: 'Enero',
    February: 'Febrero',
    March: 'Marzo',
    April: 'Abril',
    May: 'Mayo',
    June: 'Junio',
    July: 'Julio',
    August: 'Agosto',
    September: 'Septiembre',
    October: 'Octubre',
    November: 'Noviembre',
    December: 'Diciembre',
    onlyMyBookings: 'Mis citas',
    rowsPerPage: 'Filas por página',
    whyIncident:
      'Para completar esta casilla analizar la causa raíz verificando los factores que aplican al colaborador, máquina, entorno, producto, procedimiento de trabajo, que corrigiendolos habrían evitado la ocurrencia del accidente',
    incidentAlone: 'De forma individual',
    incidentWithHelp: 'Con ayuda de otro colaborador',
    botWelcomeMessage:
      '¡Hola! Soy tu asistente de estadísticas. ¿Qué datos te gustaría visualizar? Puedes preguntarme sobre sesiones, tiempo, tiendas, zonas afectadas, y más.',
    botTip: `Puedes preguntar cosas como "Muéstrame las sesiones por mes" o "¿Cuántas sesiones hay por tienda?`,
    writeQuestion: 'Escribe tu consulta...',
    manuals: 'Manuales',
    noShowBookings: 'Citas sin asistencia',
    noShowBookingsDescription: 'Exporta un histórico de las citas en las que el colaborador no ha asistido',
    cancelAndModified: 'Cancelaciones y modificaciones',
    cancelAndModifiedDesc: 'Exporta un histórico de las citas canceladas y/o modificadas',
    exportActualMonthDesc: 'Exporta un registro de las citas del mes actual y su estado',
    exportActualMonth: 'Resumen mensual',
    monthlyBookingsStoreDesc: 'Exporta un registro de las citas del mes actual realizadas por tienda',
    monthlyBookingsStore: 'Resumen mensual(Solo admin)',
    noShowRankingDesc: 'Exporta un registro de las citas no completadas con un ranking de pacientes',
    showRankingDesc: 'Exporta un registro de las citas completadas con un ranking de pacientes',
    noShowRanking: 'Registro histórico citas no completadas(Solo admin)',
    showRanking: 'Registro histórico citas completadas(Solo admin)',
    checkFacturationDesc: 'Consultar previsión facturacion',
    checkFacturation: 'Ver facturación(Solo admin)',
    sendInvoicesStoresDesc: 'Enviar facturación a almacenes',
    sendInvoicesStores: 'Enviar facturación(Solo admin)',
    monthlyImpactReportEmail: 'Informe Mensual Email',
    monthlyImpactReportEmailDesc: 'Envía por email el informe del mes o del año seleccionado, de una tienda o de todas',
    internalComunication: 'Comunicación interna',
    chat: 'Chat',
    exportDataDesc: 'Exporta datos de la plataforma para su análisis',
    survey: 'Encuesta',
    surveyDesc: 'Ayúdanos a mejorar, Rellena esta encuesta de calidad en menos de 1 minuto',
    daysService: 'Días de Servicio',
    daysServiceDesc: 'Consulta los horarios de servicio en cada tienda',
    citasEntreAlmacenesDesc: 'Registro de citas entre almacenes',
    citasEntreAlmacenes: 'Citas entre almacenes',
    surveyDone: 'Muchas gracias por haber participado en la encuesta',
    surveyStepOne: 'Estás en una encuesta anónima….¡Adelante! Tu valoración es realmente importante para nosotros.',
    surveyStepTwo: 'Puntue del 1 al 10 la calidad de las sesiones de fisioterapia',
    surveyStepThree: 'Cualificación profesional del fisioterapeuta',
    surveyFour: '¿El fisioterapeuta cumple los tiempos del servicio correctamente?',
    surveyStepEight: 'Puntue del 1 al 10 la eficacia de Metaphysio en la gestión del servicio',
    surveyStepSeven: 'Atención y trato recibido en todo momento por el fisioterapeuta',
    surveyStepSix: 'Su fisioterapeuta le informa en todo momento sobre el tratamiento a realizar',
    surveyStepFive: 'Puntue del 1 al 10 la eficacia del tratamiento aplicado',
    modificacion: 'Modificación',
    good: 'Bueno',
    bad: 'Malo',
    normal: 'Normal',
    mejorable: 'Mejorable',
    surveyBad: 'Malo',
    surveyExcelent: 'Excelente',
    surveyQualificated: 'Cualificado',
    surveyNormal: 'Normal',
    SurveyLowQualify: 'Poco cualificado',
    calendarLoaded: 'Datos del calendario cargados',
    calendarError: 'Error al cargar los datos del calendario',
    errorCalendarNotExist: 'No existe calendario para esta tienda',
    errorUserData: 'Error al cargar los datos del usuario',
    errorUserUpdateData: 'Error al actualizar los datos del usuario',
    errorWhenCreatingUser: 'Error al crear el usuario',
    errorUsersList: 'Error al cargar la lista de usuarios',
    errorDeletingUser: 'Error al eliminar el usuario',
    errorGetCompanyUsers: 'Hubo un error mientras se intentaba recuperar la lista de usuarios de la compañia',
    goActualMonth: 'Ir al mes actual',
    addSelectedToOtherDays: 'Añadir los seleccionados a otros días',
    updateAvailability: 'Actualizar disponibilidad',
    assistantChatTooltip: 'Asistente de citas en Google Chat',
    assistantChatTitle: 'Asistente de citas en Google Chat',
    assistantChatText: 'Pide, consulta, cambia o cancela citas, tuyas o de tus colaboradores, escribiendo al asistente desde Google Chat.',
    assistantChatSpamHint: 'La primera vez Google te avisará de que la invitación puede ser spam. Es normal: pulsa «Aceptar de todos modos» (Accept anyway).',
    assistantChatPreparing: 'Preparando tu chat…',
    assistantChatError: 'No se ha podido abrir el chat. Inténtalo de nuevo en unos minutos.',
    assistantChatRetry: 'Reintentar',
    assistantChatOpen: 'Abrir Google Chat',
    reservedSlot: 'Reservada',
    releaseSlotTitle: '¿Liberar la franja del {date} a las {time}?',
    releaseSlotText: 'La franja volverá a estar disponible para reservar. Los cambios de disponibilidad que no hayas guardado se perderán.',
    releaseSlotActiveBookings: 'Ojo: sigue habiendo {count} cita(s) en esta franja ({names}). Si la liberas se podrá volver a reservar.',
    releaseSlotBtn: 'Liberar',
    slotReleased: 'Franja liberada',
    releaseSlotError: 'No se ha podido liberar la franja',
    selectDaySeeAvailability: 'Selecciona un día para ver la disponibilidad',
    ready: 'Listo',
    bookingsHistory: 'Historial de citas',
    downloadPDF: 'Descargar a PDF',
    selectCompanySeeResult: 'Selecciona una compañia para ver los resultados',
    noAvailableResults: 'No hay resultados disponibles',
    statisticsWelcome: 'Bienvenido al asistente de estadísticas',
    statisticsHelp:
      'Escribe tu consulta en el chat para comenzar a visualizar datos. Puedes preguntar sobre sesiones, tiempo, tiendas, zonas afectadas y más.',
    statiticsExamplesTitle: 'Ejemplos de consultas:',
    statiticsExamples1: 'Almacenes ordenados por citas realizadas en los últimos 6 meses',
    statiticsExamples2: 'Los 3 sectores con más citas de cada almacén este año',
    statiticsExamples3: 'Almacenes con más faltas de asistencia',
    statiticsExamples4: 'Gráfico de la evolución de citas por mes',
    statiticsExamples5: '¿Cuál es la zona corporal más tratada?',
    statiticsTitle: 'Asistente de estadísticas IA',
    statiticsSubTitle: 'Estadisticas en tiempo real',
    statiticsCharts: 'Gráficos',
    statiticsData: 'Consultar Datos'
  },
  en: {
    // STORES
    stores: 'Stores',
    bookings: 'Bookings',
    booking: 'Booking',
    companies: 'Companies',
    company: 'Company',
    store: 'Store',
    addStore: 'Add Store',
    companyDeleted: 'Company deleted',
    companyCreated: 'Company created',
    companyUpdated: 'Company updated',
    addCompany: 'Add Company',
    storeDeleted: 'Store deleted',
    storeCreated: 'Store created',
    storeUpdated: 'Store updated',
    mainCashier: 'Main cashier',
    addBooking: 'Add Booking',
    editBooking: 'Edit Booking',
    addBookings: 'Add Bookings',
    addBookingInterStores: 'Add inter-stores booking',
    searchBookings: 'Search Bookings',
    bookingDeleted: 'Booking deleted',
    bookingCancelledCantSign: 'This booking has been cancelled and cannot be signed',
    bookingCreated: 'Booking created',
    bookingUpdated: 'Booking updated',
    slotTaken: 'The selected time slot has just been taken. Please choose another.',
    slotNotFound: 'The selected time slot is no longer available in the calendar. Reload and choose another.',
    bookingCreatedPendingAuth: 'Booking created. Pending manager authorization.',
    reason: 'Reason',
    medicalHistory: 'Medical history',
    notes: 'Notes',
    patient: 'Patient',
    cif: 'CIF',
    positionJob: 'Position',
    positionJobLow: 'position',
    positionJobs: 'Positions',
    physios: 'Physios',
    locations: 'Locations',
    storeName: 'Store name',
    storeUsers: 'Store users',
    searchStore: 'Search stores',
    role: 'Role',
    lastname: '1st Surname',
    lastname2: '2nd Surname',
    lastnames: 'Surnames',
    userResponsable: 'User responsable',
    noOptions: 'No actions available',
    product: 'Product',
    workWindow: 'Work window',
    when: 'When did it happen?',
    where: 'Where did it happen?',
    category: 'Category',
    signed: 'Signed',
    sinthomesRelated: 'Affected area',
    whoParticipatedAnalyse: 'Participate in the analysis',
    testigos: 'Witnesses',
    comunPatology: 'Common pathology',
    bookingReason: 'Booking reason',
    campaignId: 'Campaign ID',
    campaignName: 'Campaign name',
    bookingDetail: 'Booking detail',
    createdBy: 'Booked by',
    userDetail: 'User detail',
    incidentDetail: 'Incident detail',
    campaignDetail: 'Campaign detail',
    incidentId: 'Incident ID',
    bookingId: 'Booking ID',
    sign: 'Sign',
    daysSinceDayOff: 'Days since last day off',
    injuredWorker: 'Injured worker',
    availabilityUpdated: 'Availability updated',
    filterByRole: 'Filter by position',
    filterByCompany: 'Filter by company',
    filterByStore: 'Filter by store',
    selectDate: 'Select a date',
    // OLDER
    login: 'Login',
    loginTitle: 'Metaphysio Access',
    welcomeTitle1: 'Driving the future of',
    welcomeTitle2: 'occupational health',
    welcomeSubtitle: 'Physiotherapy management tool for companies',
    welcomePill1: 'Booking management',
    welcomePill2: 'Employees',
    welcomePill3: 'Occupational prevention',
    welcomePill4: 'Productivity',
    password: 'Password',
    passwordChanged: 'Password has been updated successfully',
    passwordChangingError: 'There was a problem trying to update the password, please try again later.',
    incorrectPassword: 'The current password entered is incorrect',
    newPassword: 'New password',
    repeatNewPassword: 'Repeat your new password',
    maintainSession: 'Keep me logged in',
    forgotPass: 'I forgot my password',
    newEmail: 'New email',
    changeEmail: 'Change email',
    emailInUse: 'This email is already in use',
    weSendEmail: 'We have sent you an email',
    weSendEmail2: 'We have sent a link to your new email to verify your account.',
    recoverYourPassword: 'Check your inbox to reset your password. You may need to check your spam folder.',
    errorWhenSendingEmail1: 'Error sending email',
    errorWhenSendingEmail2: 'There was an error sending the password reset email, please try again later.',
    search: 'Search',
    area: 'Area',
    update: 'Update',
    edit: 'Edit',
    add: 'Add',
    accept: 'Accept',
    downloadQr: 'Download QR',
    delete: 'Delete',
    cancel: 'Cancel',
    cancelled: 'Cancelled',
    name: 'Name',
    email: 'Email',
    nameSurname: 'Name and surnames',
    information: 'Information',
    payments: 'Payments',
    state: 'State',
    address: 'Address',
    phone: 'Phone',
    message: 'Message',
    age: 'Age',
    description: 'Description',
    contactPerson: 'Contact person',
    beneficiaryName: 'Beneficiary name',
    optional: 'Optional',
    nationalId: 'NIF/CIF',
    quantity: 'Quantity',
    quality: 'Quality',
    likes: 'Favorites',
    summary: 'Summary',
    general: 'General',
    city: 'City',
    registerDate: 'Register date',
    contact: 'Contact',
    export: 'Export',
    deselectAll: 'Deselect all',
    selectAll: 'Select all',
    selected: 'Selected',
    selecteds: 'Selecteds',
    deactivated: 'Deactivated',
    deactivate: 'Deactivate',
    deactivateAll: 'Change status',
    activate: 'Activate',
    activated: 'Activated',
    value: 'Value',
    history: 'History',
    hour: 'hour',
    minutes: 'minutes',
    min: 'min',
    ayuda: 'Help',
    faq: 'FAQ',
    horarios: 'Schedules',
    helpCenter: 'Help center',
    someIncorrectData: 'Some incorrect data?',
    instagram: 'Instagram',
    deleted: 'Deleted',
    recoverPassword: 'Recover password',
    recoverPasswordText: 'We will send you an email to update your password',
    emailError: 'Enter a correct email',
    notifications: 'Notifications',
    settings: 'Settings',
    logout: 'Logout',
    logoutText: 'You are about to log out, are you sure?',
    next: 'Next',
    return: 'Return',
    save: 'Save',
    import: 'Import',
    statusChanged: 'Status has been changed',
    status: 'Status',
    active: 'Active',
    disabled: 'Inactive',
    location: 'Location',
    only: 'Only',
    noResults: 'No results',
    moreThanThreeCharacters: 'Start typing to see results',
    continue: 'Continue',
    percent: 'Percent',
    csvImport: 'Import CSV',
    importUsers: 'Import users',
    waiting: 'Waiting',
    changePassword: 'Change password',
    successDialogUpdatePassword: 'Password changed successfully',
    newOrdersCancelationsEmails: 'Emails about new orders and cancellations',
    offersEmail: 'Emails with special offers and promotions',
    selectTime: 'Select time',
    todayPlate: "Today's Plate",
    date: 'Date',
    exportData: 'Export Data ↓',
    yourRestaurant: 'Your restaurant',
    management: 'Management',
    expirationDate: 'Expiration date',
    byDefault: '↪ By default:',
    loadMore: 'Load more',
    noFilters: 'No filters',
    complete: 'Sign',
    completeBooking: 'Complete booking with patient signature',
    askBooking: 'Request Booking',
    timezone: 'Timezone',
    bookingCompleted: 'Attendance confirmed',
    bookingCompletedError: 'There was an error closing the booking',
    signedError: 'There was an error saving the signature',

    completed: 'Attends',
    noAssist: "Doesn't attend",
    assist: 'Assistance',
    pending: 'Pending',
    close: 'Close',
    closeReason: 'Incident closing reason',
    closeDate: 'Closing date',
    incidentCloseOk: 'Investigation closed successfully',
    sessions: 'Sessions',
    // HELP
    help: 'Help',
    helpEmail: 'If you need assistance, contact us at ',
    helpInstagram: 'Follow us on social media and stay up to date with Metaphysio news.',
    helpPhone: 'If you need assistance, contact us directly at ',
    termsConditions: 'Legal Notice',
    privacyPolicy: 'Privacy Policy',
    cookiesPolicy: 'Cookies Policy',
    contactMetaphysio: 'Contact Metaphysio',
    contactMetaphysio2: 'Contact Metaphysio',
    metaphysioPolitic: 'Metaphysio Policy',
    query: 'Query',
    questionSended: 'Query sent',
    send: 'Send',

    // ERRORS
    hasBeenAnError: 'There was an error, please try again later',
    changeCompleted: 'Change completed successfully',
    // USERS
    users: 'Users',
    user: 'user',
    addUser: 'Add user',
    searchUser: ' Search user',
    userName: 'Username',
    userDeleted: 'The user has been deleted',
    userCreated: 'The user has been created',
    userUpdated: 'The user has been updated',
    emailSent: 'Email sent successfully',
    emailSentDialogText1: 'An email has been sent to ',
    emailSentDialogText2: 'with instructions to validate their user account.',
    errorDialogUser: 'The email entered is already in use. Contact the user to use a different one.',
    preUser: 'Pre-User',
    birthday: 'Birth date',
    gender: 'Gender',
    sector: 'Sector',
    position: 'Position',
    employeeId: 'Employee number(Ldap)',
    genderEditing: 'Choose the user gender',
    personalData: 'Personal Data',
    workingSince: 'Start date',
    comercialManager: 'Commercial manager',
    cashier: 'Cashier',
    cashManager: 'Cash manager',
    logisticManager: 'Logistic manager',
    seller: 'Seller',
    whatHappened: 'What happened?',
    why: 'Why?',
    how: 'How?',
    affectedZone: 'Affected area',
    professionalChannel: 'Professional channel',
    paymentMethods: 'Payment methods',
    man: 'Man',
    woman: 'Woman',
    file: 'File',
    importSuccess: 'Import completed',
    importUsersTitle: 'Users added successfully',
    importUsersText: 'We have sent an email to the users with instructions to validate their accounts.',
    importUsersError: 'Oops, something went wrong',
    importUsersErrorText1: 'The following emails are already in use:',
    importUsersErrorText2: 'Contact these users to use different emails.',
    importUsersPrevalidation: 'The fields "user", "surname" and "email" are mandatory in all rows.',
    importFileSuccess: 'Correct import file',
    confirmWithSign: 'Confirm attendance with signature',
    confirmWithSignIncident: 'Sign incident investigation report',
    incidentSignedOk: 'Incident signed successfully',
    incidentSigned: 'Signed',
    incidentNotSigned: 'Both missing',
    incidentNotSignedWorker: 'Collaborator missing',
    incidentNotSignedResponsable: 'Responsible missing',
    morning: 'Morning',
    afternoon: 'Afternoon',
    // WEEKDAYS
    today: 'Today',
    tomorrow: 'Tomorrow',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    // LOGIN ERRORS
    ERR_NO_EMAIL: 'The email entered does not belong to any account. Try another one.',
    ERR_INVALID_EMAIL: 'The email entered is not valid',
    ERR_WRONG_PASS: 'Incorrect password. Try again.',
    ERR_PASS_WRONG_TIMES: 'Incorrect password too many times. Try again in 5 minutes or click "I forgot my password"',
    // ERR_PASS_REQUIREMENTS: 'The password does not meet the required requirements, we have sent you an email to reset it',
    ERR_PASS_REQUIREMENTS:
      'The password does not meet the required requirements, click on I forgot my password to request an email to change it.',
    // 404
    returnToList: 'Please go back to the list and choose another.',
    notFound: 'We have not found anything',
    // ERRORBOUNDARY
    boundaryTitle: 'We are sorry :( there has been an error',
    errorEmailValidation: 'It should be a valid email',
    errorEmployeeIdValidation: 'The employee number is repeated',
    // NAVIGATION
    machines: 'Machines',
    processes: 'Processes',
    statitics: 'Statistics',
    calendars: 'Calendars',
    calendar: 'Calendar',
    sectors: 'Sectors',
    areas: 'Areas',
    hierarchies: 'Hierarchies',
    // companies: 'Compañias',
    pathologies: 'Pathologies',
    incidents: 'Incidents',
    incident: 'Incident',
    issues: 'Issues',
    searchIssues: 'Search issues',
    campaigns: 'Campaigns',
    rrhh: 'HR',
    admin: 'Admin',
    utils: 'Utils',
    searchCompany: 'Search company',
    // Pathologies
    pathologiesDeleted: 'Pathology deleted',
    searchPathologies: 'Search pathology',
    addPathologies: 'Add pathology',
    pathologyCreated: 'Pathology created',
    pathologyUpdated: 'Pathology updated',
    pathology: 'Pathology',
    // Machines
    machinesDeleted: 'Machine deleted',
    searchMachines: 'Search machine',
    searchRoles: 'Search position',
    addMachines: 'Add machine',
    machinesCreated: 'Machine created',
    machinesUpdated: 'Machine updated',
    machine: 'Machine',
    // Incident
    incidentDeleted: 'Incident deleted',
    searchIncident: 'Search incident',
    addIncident: 'Add incident',
    editIncident: 'Edit incident',
    incidentCreated: 'Incident created',
    incidentUpdated: 'Incident updated',
    incidentResearch: 'Add Incident Research',
    open: 'Open',
    alta: 'Discharge',
    noResolution: 'No resolution',
    full: 'Maximum sessions',
    statusIncident: 'Investigation status',
    // Sectors
    sectorsDeleted: 'Sector deleted',
    rolesDeleted: 'Role deleted',
    searchSectors: 'Search sector',
    addSectors: 'Add sector',
    sectorsCreated: 'Sector created',
    sectorsUpdated: 'Sector updated',
    // Areas
    areasDeleted: 'Area deleted',
    searchAreas: 'Search area',
    addAreas: 'Add area',
    areasCreated: 'Area created',
    areasUpdated: 'Area updated',
    // Processes
    processesDeleted: 'Process deleted',
    searchProcesses: 'Search process',
    addProcesses: 'Add process',
    processesCreated: 'Process created',
    processesUpdated: 'Process updated',
    process: 'Process',
    // Campaigns
    campaignsDeleted: 'Campaign deleted',
    searchCampaigns: 'Search campaign',
    addCampaigns: 'Add campaign',
    editCampaign: 'Edit campaign',
    campaignsCreated: 'Campaign created',
    campaignsUpdated: 'Campaign updated',
    incorcamp: 'Incident/Campaign/PC',
    campaign: 'Campaign',
    // ROLES
    roles: 'Roles',
    addRoles: 'Add roles',
    addPositions: 'Add positions',
    rolesUpdated: 'Role updated',
    rolesCreated: 'Role created',
    hr: 'HR',
    physio: 'Physiotherapist',
    worker: 'Worker',
    storeManager: 'Store manager',
    director: 'role4',
    departmentManager: 'Department manager',
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
    onlyMyBookings: 'My bookings',
    rowsPerPage: 'Rows per page',
    whyIncident:
      'To complete this box, analyze the root cause by checking the factors that apply to the employee, machine, environment, product, work procedure, which by correcting them would have prevented the occurrence of the accident',
    incidentAlone: 'Individually',
    incidentWithHelp: 'With help from another employee',
    botWelcomeMessage:
      'Hi! I am your statistics assistant. What data would you like to visualize? You can ask me about sessions, time, stores, affected areas, and more.',
    botTip: `You can ask things like "Show me sessions by month" or "How many sessions are there per store?"`,
    writeQuestion: 'Write your question...',
    manuals: 'Manuals',
    noShowBookings: 'No-show bookings',
    noShowBookingsDescription: 'Export a history of bookings where the employee did not attend',
    cancelAndModified: 'Cancellations and modifications',
    cancelAndModifiedDesc: 'Export a history of cancelled and/or modified bookings',
    exportActualMonthDesc: "Export a record of the current month's bookings and their status",
    exportActualMonth: 'Monthly summary',
    monthlyBookingsStoreDesc: "Export a record of the current month's bookings made by store",
    monthlyBookingsStore: 'Monthly summary(Admin only)',
    noShowRankingDesc: 'Export a record of uncompleted bookings with a patient ranking',
    showRankingDesc: 'Export a record of completed bookings with a patient ranking',
    noShowRanking: 'Historical record of uncompleted bookings(Admin only)',
    showRanking: 'Historical record of completed bookings(Admin only)',
    checkFacturationDesc: 'Check billing forecast',
    checkFacturation: 'View billing(Admin only)',
    sendInvoicesStoresDesc: 'Send billing to stores',
    monthlyImpactReportEmail: 'Monthly Report Email',
    monthlyImpactReportEmailDesc: 'Email the selected month or year report for one store or all of them',
    sendInvoicesStores: 'Send billing(Admin only)',
    internalComunication: 'Internal communication',
    chat: 'Chat',
    exportDataDesc: 'Export platform data for analysis',
    survey: 'Survey',
    surveyDesc: 'Help us improve, fill out this quality survey in less than 1 minute',
    daysService: 'Service Days',
    daysServiceDesc: 'Check service hours at each store',
    citasEntreAlmacenesDesc: 'Record of inter-store bookings',
    citasEntreAlmacenes: 'Inter-store bookings',
    surveyDone: 'Thank you very much for participating in the survey',
    surveyStepOne: 'You are in an anonymous survey... Go ahead! Your feedback is really important to us.',
    surveyStepTwo: 'Rate the quality of physiotherapy sessions from 1 to 10',
    surveyStepThree: 'Professional qualification of the physiotherapist',
    surveyFour: 'Does the physiotherapist correctly meet the service times?',
    surveyStepEight: 'Rate the effectiveness of Metaphysio in managing the service from 1 to 10',
    surveyStepSeven: 'Attention and treatment received at all times by the physiotherapist',
    surveyStepSix: 'Your physiotherapist informs you at all times about the treatment to be performed',
    surveyStepFive: 'Rate the effectiveness of the applied treatment from 1 to 10',
    modificacion: 'Modification',
    cancelledBy: 'Cancelled by',
    newDate: 'New date',
    newHour: 'New time',
    editedBy: 'Edited by',
    good: 'Good',
    bad: 'Bad',
    normal: 'Normal',
    mejorable: 'Could be better',
    surveyBad: 'Bad',
    surveyExcelent: 'Excellent',
    surveyQualificated: 'Qualified',
    surveyNormal: 'Normal',
    SurveyLowQualify: 'Low qualified',
    calendarLoaded: 'Calendar data loaded',
    calendarError: 'Error loading calendar data',
    errorCalendarNotExist: 'Calendar does not exist for this store',
    errorUserData: 'Error loading user data',
    errorUserUpdateData: 'Error updating user data',
    errorWhenCreatingUser: 'Error creating user',
    errorUsersList: 'Error loading user list',
    errorDeletingUser: 'Error deleting user',
    errorGetCompanyUsers: 'There was an error while trying to retrieve the company user list',
    goActualMonth: 'Go to current month',
    addSelectedToOtherDays: 'Add selected to other days',
    updateAvailability: 'Update availability',
    assistantChatTooltip: 'Booking assistant on Google Chat',
    assistantChatTitle: 'Booking assistant on Google Chat',
    assistantChatText: 'Book, check, change or cancel appointments, yours or your colleagues\', by writing to the assistant on Google Chat.',
    assistantChatSpamHint: 'The first time, Google will warn you that the invite may be spam. That is expected: click «Accept anyway».',
    assistantChatPreparing: 'Preparing your chat…',
    assistantChatError: 'The chat could not be opened. Please try again in a few minutes.',
    assistantChatRetry: 'Retry',
    assistantChatOpen: 'Open Google Chat',
    reservedSlot: 'Reserved',
    releaseSlotTitle: 'Release the slot on {date} at {time}?',
    releaseSlotText: 'The slot will be available for booking again. Any unsaved availability changes will be lost.',
    releaseSlotActiveBookings: 'Warning: there are still {count} booking(s) in this slot ({names}). If you release it, it can be booked again.',
    releaseSlotBtn: 'Release',
    slotReleased: 'Slot released',
    releaseSlotError: 'The slot could not be released',
    selectDaySeeAvailability: 'Select a day to see availability',
    ready: 'Ready',
    bookingsHistory: 'Bookings history',
    downloadPDF: 'Download to PDF',
    selectCompanySeeResult: 'Select a company to see results',
    noAvailableResults: 'No available results',
    statisticsWelcome: 'Welcome to the statistics assistant',
    statisticsHelp:
      'Type your query in the chat to start visualizing data. You can ask about sessions, time, stores, affected areas, and more.',
    statiticsExamplesTitle: 'Example prompts:',
    statiticsExamples1: 'Stores ranked by completed appointments in the last 6 months',
    statiticsExamples2: 'Top 3 sectors with most appointments per store this year',
    statiticsExamples3: 'Stores with the most no-shows',
    statiticsExamples4: 'Chart of appointments per month',
    statiticsExamples5: 'What is the most treated body area?',
    statiticsTitle: 'AI Statistics Assistant',
    statiticsSubTitle: 'Real-time statistics',
    statiticsCharts: 'Charts',
    statiticsData: 'Query Data'
  },
  pt: {
    // STORES
    stores: 'Armazéns',
    bookings: 'Consultas',
    booking: 'Consulta',
    companies: 'Companhias',
    company: 'Companhia',
    store: 'Armazém',
    addStore: 'Adicionar Armazém',
    companyDeleted: 'Armazém eliminado',
    companyCreated: 'Armazém criado',
    companyUpdated: 'Armazém atualizado',
    addCompany: 'Adicionar Companhia',
    storeDeleted: 'Armazém eliminado',
    storeCreated: 'Armazém criado',
    storeUpdated: 'Armazém atualizado',
    mainCashier: 'Caixa principal',
    addBooking: 'Adicionar Consulta',
    editBooking: 'Modificar consulta',
    addBookings: 'Adicionar Consultas',
    addBookingInterStores: 'Adicionar consulta entre armazéns',
    searchBookings: 'Procurar Consultas',
    bookingDeleted: 'Consulta eliminada',
    bookingCancelledCantSign: 'Esta consulta foi anulada e não pode ser assinada',
    bookingCreated: 'Consulta criada',
    bookingUpdated: 'Consulta atualizada',
    slotTaken: 'O horário selecionado acabou de ser ocupado. Escolha outro.',
    slotNotFound: 'O horário selecionado já não está disponível no calendário. Recarregue e escolha outro.',
    bookingCreatedPendingAuth: 'Consulta criada. Pendente de autorização do responsável.',
    reason: 'Motivo',
    medicalHistory: 'Histórico médico',
    notes: 'Notas',
    patient: 'Paciente',
    cif: 'CIF',
    positionJob: 'Posição',
    positionJobLow: 'posição',
    positionJobs: 'Posições',
    physios: 'Fisioterapeutas',
    locations: 'Localizações',
    storeName: 'Nome do Armazém',
    storeUsers: 'Usuários do Armazém',
    searchStore: 'Procurar armazéns',
    role: 'Função',
    lastname: '1º Sobrenome',
    lastname2: '2º Sobrenome',
    lastnames: 'Sobrenomes',
    userResponsable: 'Usuário Responsável',
    noOptions: 'Nenhuma ação disponível',
    product: 'Produto',
    workWindow: 'Turno',
    when: 'Quando aconteceu?',
    where: 'Onde aconteceu?',
    category: 'Categoria',
    signed: 'Assinado',
    sinthomesRelated: 'Zona afetada',
    whoParticipatedAnalyse: 'Participam na análise',
    testigos: 'Testemunhas',
    comunPatology: 'Patologia Comum',
    bookingReason: 'Motivo da Consulta',
    campaignId: 'Id Campanha',
    campaignName: 'Nome da Campanha',
    bookingDetail: 'Detalhe da consulta',
    createdBy: 'Agendado por',
    userDetail: 'Detalhe do Usuário',
    incidentDetail: 'Detalhe do Incidente',
    campaignDetail: 'Detalhe da Campanha',
    incidentId: 'Id do Incidente',
    bookingId: 'Id da Consulta',
    sign: 'Assinar',
    daysSinceDayOff: 'Dias desde o último dia de folga',
    injuredWorker: 'Trabalhador lesionado',
    availabilityUpdated: 'Disponibilidade atualizada',
    filterByRole: 'Filtrar por posição',
    filterByCompany: 'Filtrar por companhia',
    filterByStore: 'Filtrar por armazém',
    // OLDER
    login: 'Iniciar Sessão',
    loginTitle: 'Acesso Metaphysio',
    welcomeTitle1: 'Impulsionando o futuro da',
    welcomeTitle2: 'saúde ocupacional',
    welcomeSubtitle: 'Ferramenta de gestão de fisioterapia para empresas',
    welcomePill1: 'Gestão de consultas',
    welcomePill2: 'Funcionários',
    welcomePill3: 'Prevenção laboral',
    welcomePill4: 'Produtividade',
    password: 'Senha',
    passwordChanged: 'A senha foi atualizada com sucesso',
    passwordChangingError: 'Houve um problema ao tentar atualizar a senha, por favor tente novamente mais tarde.',
    incorrectPassword: 'A senha atual inserida está incorreta',
    newPassword: 'Nova senha',
    repeatNewPassword: 'Repita sua nova senha',
    maintainSession: 'Manter sessão iniciada',
    forgotPass: 'Esqueci minha senha',
    newEmail: 'Novo email',
    changeEmail: 'Mudar email',
    emailInUse: 'Este email já está em uso',
    weSendEmail: 'Enviamos um email para você',
    weSendEmail2: 'Enviamos um link para o seu novo email para verificar sua conta.',
    recoverYourPassword: 'Verifique sua caixa de entrada para redefinir sua senha. Você pode precisar verificar sua pasta de spam.',
    errorWhenSendingEmail1: 'Erro ao enviar email',
    errorWhenSendingEmail2: 'Houve um erro ao enviar o email de redefinição de senha, por favor tente novamente mais tarde.',
    search: 'Procurar',
    area: 'Área',
    update: 'Atualizar',
    edit: 'Modificar',
    modificacion: 'Modificación',
    add: 'Adicionar',
    accept: 'Aceitar',
    downloadQr: 'Baixar QR',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    cancelled: 'Cancelado',
    name: 'Nome',
    email: 'Email',
    nameSurname: 'Nome e sobrenomes',
    information: 'Informação',
    payments: 'Pagamentos',
    state: 'Estado',
    address: 'Endereço',
    phone: 'Telefone',
    message: 'Mensagem',
    age: 'Idade',
    description: 'Descrição',
    contactPerson: 'Pessoa de contato',
    beneficiaryName: 'Nome do beneficiário',
    optional: 'Opcional',
    nationalId: 'NIF/CIF',
    quantity: 'Quantidade',
    quality: 'Qualidade',
    likes: 'Favoritos',
    summary: 'Resumo',
    general: 'Geral',
    city: 'Cidade',
    registerDate: 'Data de registro',
    contact: 'Contato',
    export: 'Exportar',
    deselectAll: 'Desmarcar todos',
    selectAll: 'Selecionar todos',
    selected: 'Selecionado',
    selecteds: 'Selecionados',
    deactivated: 'Desativado',
    deactivate: 'Desativar',
    deactivateAll: 'Modificar estado',
    activate: 'Ativar',
    activated: 'Ativado',
    value: 'Valor',
    history: 'Histórico',
    hour: 'hora',
    minutes: 'minutos',
    min: 'min',
    ayuda: 'Help',
    faq: 'Perguntas frequentes',
    horarios: 'Horários',
    helpCenter: 'Centro de ajuda',
    someIncorrectData: 'Algum dado incorreto?',
    instagram: 'Instagram',
    deleted: 'Eliminado',
    recoverPassword: 'Recuperar senha',
    recoverPasswordText: 'Enviaremos um email para você atualizar sua senha',
    emailError: 'Insira um email correto',
    notifications: 'Notificações',
    settings: 'Configurações',
    logout: 'Sair',
    logoutText: 'Você está prestes a sair, tem certeza?',
    next: 'Próximo',
    return: 'Voltar',
    save: 'Salvar',
    import: 'Importar',
    statusChanged: 'O status foi alterado',
    status: 'Status',
    active: 'Ativo',
    disabled: 'Inativo',
    location: 'Localidade',
    only: 'Apenas',
    noResults: 'Sem resultados',
    moreThanThreeCharacters: 'Comece a digitar para ver os resultados',
    continue: 'Continuar',
    percent: 'Porcentagem',
    csvImport: 'Importar CSV',
    importUsers: 'Importar usuários',
    waiting: 'Esperando',
    changePassword: 'Mudar senha',
    successDialogUpdatePassword: 'Senha alterada com sucesso',
    newOrdersCancelationsEmails: 'Emails sobre novos pedidos e cancelamentos',
    offersEmail: 'Emails com ofertas especiais e promoções',
    selectTime: 'Selecionar hora',
    date: 'Data',
    exportData: 'Exportar Dados ↓',
    management: 'Gestão',
    expirationDate: 'Data de vencimento',
    byDefault: '↪ Por padrão:',
    loadMore: 'Carregar mais',
    noFilters: 'Sem filtros',
    complete: 'Assinar',
    completeBooking: 'Completar consulta com assinatura do paciente',
    askBooking: 'Solicitar Consulta',
    timezone: 'Fuso horário',
    bookingCompleted: 'Presença confirmada',
    bookingCompletedError: 'Houve um erro ao fechar a consulta',
    signedError: 'Houve um erro ao salvar a assinatura',

    completed: 'Comparece',
    noAssist: 'Não comparece',
    assist: 'Assistência',
    pending: 'Pendente',
    close: 'Fechar',
    closeReason: 'Motivo de fechamento do incidente',
    closeDate: 'Data de fechamento',
    incidentCloseOk: 'Investigação fechada com sucesso',
    sessions: 'Sessões',

    // HELP
    help: 'Ajuda',
    helpEmail: 'Se você precisar de assistência, entre em contato conosco em ',
    helpInstagram: 'Siga-nos nas redes sociais e fique por dentro das novidades da Metaphysio.',
    helpPhone: 'Se você precisar de assistência, entre em contato direto conosco em ',
    termsConditions: 'Aviso Legal',
    privacyPolicy: 'Política de Privacidade',
    cookiesPolicy: 'Política de Cookies',
    contactMetaphysio: 'Contactar Metaphysio',
    contactMetaphysio2: 'Contacte a Metaphysio',
    metaphysioPolitic: 'Política Metaphysio',
    query: 'Consulta',
    questionSended: 'Consulta enviada',
    send: 'Enviar',
    selectDate: 'Selecionar uma data',
    // ERRORS
    hasBeenAnError: 'Houve um erro, por favor tente novamente mais tarde',
    changeCompleted: 'Alteração concluída com sucesso',
    // USERS
    users: 'Usuários',
    user: 'usuário',
    addUser: 'Adicionar usuário',
    searchUser: ' Procurar usuário',
    userName: 'Nome de usuário',
    userDeleted: 'O usuário foi eliminado',
    userCreated: 'O usuário foi criado',
    userUpdated: 'O usuário foi atualizado',
    emailSent: 'Email enviado com sucesso',
    emailSentDialogText1: 'Um email foi enviado para ',
    emailSentDialogText2: 'com instruções para validar sua conta de usuário.',
    errorDialogUser: 'O email inserido já está em uso. Entre em contato com o usuário para usar outro diferente.',
    preUser: 'Pré-Usuário',
    birthday: 'Data de nascimento',
    gender: 'Gênero',
    sector: 'Setor',
    position: 'Posição',
    employeeId: 'Número do empregado(Ldap)',
    genderEditing: 'Escolha o gênero do usuário',
    personalData: 'Dados Pessoais',
    workingSince: 'Data de início',
    comercialManager: 'Gerente comercial',
    cashier: 'Caixa',
    cashManager: 'Gerente de caixa',
    logisticManager: 'Gerente de logística',
    seller: 'Vendedor',
    whatHappened: 'O que aconteceu?',
    why: 'Por quê?',
    how: 'Como?',
    affectedZone: 'Zona afetada',
    professionalChannel: 'Canal profissional',
    paymentMethods: 'Métodos de pagamento',
    man: 'Homem',
    women: 'Mulher',
    file: 'Arquivo',
    importSuccess: 'Importação concluída',
    importUsersTitle: 'Usuários adicionados com sucesso',
    importUsersText: 'Enviamos um email para os usuários com instruções para validar suas contas.',
    importUsersError: 'Ops, algo deu errado',
    importUsersErrorText1: 'Os seguintes emails já estão em uso:',
    importUsersErrorText2: 'Entre em contato com esses usuários para usar emails diferentes.',
    importUsersPrevalidation: 'Os campos "usuário", "sobrenome" e "email" são obrigatórios em todas as linhas.',
    importFileSuccess: 'Arquivo de importação correto',
    confirmWithSign: 'Confirmar presença com assinatura',
    confirmWithSignIncident: 'Assinar relatório de investigação de incidente',
    incidentSignedOk: 'Incidente assinado com sucesso',
    incidentSigned: 'Assinado',
    incidentNotSigned: 'Ambos faltam',
    incidentNotSignedWorker: 'Colaborador em falta',
    incidentNotSignedResponsable: 'Responsável em falta',
    morning: 'Manhã',
    afternoon: 'Tarde',
    // WEEKDAYS
    today: 'Hoje',
    tomorrow: 'Amanhã',
    Monday: 'Segunda-feira',
    Tuesday: 'Terça-feira',
    Wednesday: 'Quarta-feira',
    Thursday: 'Quinta-feira',
    Friday: 'Sexta-feira',
    Saturday: 'Sábado',
    Sunday: 'Domingo',
    // LOGIN ERRORS
    ERR_NO_EMAIL: 'O email inserido não pertence a nenhuma conta. Tente outro.',
    ERR_INVALID_EMAIL: 'O email inserido não é válido',
    ERR_WRONG_PASS: 'Senha incorreta. Tente novamente.',
    ERR_PASS_WRONG_TIMES: 'Senha incorreta muitas vezes. Tente novamente em 5 minutos ou clique em "Esqueci minha senha"',
    // ERR_PASS_REQUIREMENTS: 'A senha não atende aos requisitos necessários, enviamos um email para você redefini-la',
    ERR_PASS_REQUIREMENTS:
      'A senha não atende aos requisitos necessários, clique em Esqueci minha senha para solicitar um email para alterá-la.',
    // 404
    returnToList: 'Por favor, volte para a lista e escolha outro.',
    notFound: 'Não encontramos nada',
    // ERRORBOUNDARY
    boundaryTitle: 'Lamentamos :( houve um erro',
    errorEmailValidation: 'Deve ser um email válido',
    errorEmployeeIdValidation: 'O número do empregado está repetido',
    // NAVIGATION
    machines: 'Máquinas',
    processes: 'Processos',
    statitics: 'Estatísticas',
    calendars: 'Calendários',
    calendar: 'Calendário',
    sectors: 'Setores',
    areas: 'Áreas',
    hierarchies: 'Hierarquias',
    // companies: 'Compañias',
    pathologies: 'Patologias',
    incidents: 'Incidentes',
    incident: 'Incidente',
    issues: 'Problemas',
    searchIssues: 'Procurar problemas',
    campaigns: 'Campanhas',
    rrhh: 'RH',
    admin: 'Admin',
    utils: 'Utilitários',
    searchCompany: 'Procurar companhia',
    // Pathologies
    pathologiesDeleted: 'Patologia eliminada',
    searchPathologies: 'Procurar patologia',
    addPathologies: 'Adicionar patologia',
    pathologyCreated: 'Patologia criada',
    pathologyUpdated: 'Patologia atualizada',
    pathology: 'Patologia',
    // Machines
    machinesDeleted: 'Máquina eliminada',
    searchMachines: 'Procurar máquina',
    searchRoles: 'Procurar cargo',
    addMachines: 'Adicionar máquina',
    machinesCreated: 'Máquina criada',
    machinesUpdated: 'Máquina atualizada',
    machine: 'Máquina',
    // Incident
    incidentDeleted: 'Incidente eliminado',
    searchIncident: 'Procurar incidente',
    addIncident: 'Adicionar incidente',
    editIncident: 'Modificar incidente',
    incidentCreated: 'Incidente criado',
    incidentUpdated: 'Incidente atualizado',
    incidentResearch: 'Adicionar Pesquisa de Incidente',
    open: 'Aberto',
    alta: 'Alta',
    noResolution: 'Sem resolução',
    full: 'Sessões máximas',
    statusIncident: 'Estado da investigação',
    // Sectors
    sectorsDeleted: 'Setor eliminado',
    rolesDeleted: 'Função eliminada',
    searchSectors: 'Procurar setor',
    addSectors: 'Adicionar setor',
    sectorsCreated: 'Setor criado',
    sectorsUpdated: 'Setor atualizado',
    // Areas
    areasDeleted: 'Área eliminada',
    searchAreas: 'Procurar área',
    addAreas: 'Adicionar área',
    areasCreated: 'Área criada',
    areasUpdated: 'Área atualizada',
    // Processes
    processesDeleted: 'Processo eliminado',
    searchProcesses: 'Procurar processo',
    addProcesses: 'Adicionar processo',
    processesCreated: 'Processo criado',
    processesUpdated: 'Processo atualizado',
    process: 'Processo',
    // Campaigns
    campaignsDeleted: 'Campanha eliminada',
    searchCampaigns: 'Procurar campanha',
    addCampaigns: 'Adicionar campanha',
    editCampaign: 'Modificar campanha',
    campaignsCreated: 'Campanha criada',
    campaignsUpdated: 'Campanha atualizada',
    incorcamp: 'Incidente/Campanha/PC',
    campaign: 'Campanha',
    // ROLES
    roles: 'Funções',
    addRoles: 'Adicionar funções',
    addPositions: 'Adicionar posições',
    rolesUpdated: 'Função atualizada',
    rolesCreated: 'Função criada',
    hr: 'RH',
    physio: 'Fisioterapeuta',
    worker: 'Trabalhador',
    storeManager: 'Gerente do armazém',
    director: 'role4',
    departmentManager: 'Gerente de departamento',
    January: 'Janeiro',
    February: 'Fevereiro',
    March: 'Março',
    April: 'Abril',
    May: 'Maio',
    June: 'Junho',
    July: 'Julho',
    August: 'Agosto',
    September: 'Setembro',
    October: 'Outubro',
    November: 'Novembro',
    December: 'Dezembro',
    onlyMyBookings: 'Minhas consultas',

    rowsPerPage: 'Linhas por página',
    whyIncident:
      'Para preencher este quadro, analise a causa raiz verificando os fatores que se aplicam ao empregado, máquina, ambiente, produto, procedimento de trabalho, que ao corrigi-los teria evitado a ocorrência do acidente',
    incidentAlone: 'Individualmente',
    incidentWithHelp: 'Com ajuda de outro empregado',
    botWelcomeMessage:
      'Olá! Eu sou seu assistente de estatísticas. Que dados você gostaria de visualizar? Você pode me perguntar sobre sessões, tempo, armazéns, áreas afetadas e muito mais.',
    botTip: `Você pode perguntar coisas como "Mostre-me sessões por mês" ou "Quantas sessões há por armazém?"`,
    writeQuestion: 'Escreva sua pergunta...',
    manuals: 'Manuais',
    noShowBookings: 'Consultas não comparecidas',
    noShowBookingsDescription: 'Exportar um histórico de consultas onde o empregado não compareceu',
    cancelAndModified: 'Cancelamentos e modificações',
    cancelAndModifiedDesc: 'Exportar um histórico de consultas canceladas e/ou modificadas',
    exportActualMonthDesc: 'Exportar um registro das consultas do mês atual e seu status',
    exportActualMonth: 'Resumo mensal',
    monthlyBookingsStoreDesc: 'Exportar um registro das consultas do mês atual feitas por armazém',
    monthlyBookingsStore: 'Resumo mensal(Admin only)',
    noShowRankingDesc: 'Exportar um registro de consultas não concluídas com um ranking de pacientes',
    showRankingDesc: 'Exportar um registro de consultas concluídas com um ranking de pacientes',
    noShowRanking: 'Histórico de consultas não concluídas(Admin only)',
    showRanking: 'Histórico de consultas concluídas(Admin only)',
    checkFacturationDesc: 'Verificar previsão de faturamento',
    checkFacturation: 'Ver faturamento(Admin only)',
    sendInvoicesStoresDesc: 'Enviar faturamento para armazéns',
    monthlyImpactReportEmail: 'Relatório Mensal Email',
    monthlyImpactReportEmailDesc: 'Enviar por email o relatório do mês ou do ano selecionado, de um armazém ou de todos',
    sendInvoicesStores: 'Enviar faturamento(Admin only)',
    internalComunication: 'Comunicação interna',
    chat: 'Chat',
    exportDataDesc: 'Exportar dados da plataforma para análise',
    survey: 'Pesquisa',
    surveyDesc: 'Ajude-nos a melhorar, preencha esta pesquisa de qualidade em menos de 1 minuto',
    daysService: 'Dias de Serviço',
    daysServiceDesc: 'Verificar horas de serviço em cada armazém',
    citasEntreAlmacenesDesc: 'Registro de consultas entre armazéns',
    citasEntreAlmacenes: 'Consultas entre armazéns',
    surveyDone: 'Muito obrigado por participar da pesquisa',
    surveyStepOne: 'Você está em uma pesquisa anônima... Vá em frente! Seu feedback é muito importante para nós.',
    surveyStepTwo: 'Classifique a qualidade das sessões de fisioterapia de 1 a 10',
    surveyStepThree: 'Qualificação profissional do fisioterapeuta',
    surveyFour: 'O fisioterapeuta cumpre corretamente os horários de atendimento?',
    surveyStepEight: 'Classifique a eficácia da Metaphysio na gestão do serviço de 1 a 10',
    surveyStepSeven: 'Atenção e tratamento recebidos em todos os momentos pelo fisioterapeuta',
    surveyStepSix: 'Seu fisioterapeuta informa você em todos os momentos sobre o tratamento a ser realizado',
    surveyStepFive: 'Classifique a eficácia do tratamento aplicado de 1 a 10',
    cancelledBy: 'Cancelado por',
    newDate: 'Nova data',
    newHour: 'Novo horário',
    editedBy: 'Modificado por',
    good: 'Bom',
    bad: 'Ruim',
    normal: 'Normal',
    mejorable: 'Pode ser melhor',
    surveyBad: 'Ruim',
    surveyExcelent: 'Excelente',
    surveyQualificated: 'Qualificado',
    surveyNormal: 'Normal',
    SurveyLowQualify: 'Baixa qualificação',
    calendarLoaded: 'Dados do calendário carregados',
    calendarError: 'Erro ao carregar dados do calendário',
    errorCalendarNotExist: 'O calendário não existe para este armazém',
    errorUserData: 'Erro ao carregar dados do usuário',
    errorUserUpdateData: 'Erro ao atualizar dados do usuário',
    errorWhenCreatingUser: 'Erro ao criar usuário',
    errorUsersList: 'Erro ao carregar lista de usuários',
    errorDeletingUser: 'Erro ao eliminar usuário',
    errorGetCompanyUsers: 'Houve um erro ao tentar recuperar a lista de usuários da companhia',
    goActualMonth: 'Ir para o mês atual',
    addSelectedToOtherDays: 'Adicionar selecionados a outros dias',
    updateAvailability: 'Atualizar disponibilidade',
    assistantChatTooltip: 'Assistente de marcações no Google Chat',
    assistantChatTitle: 'Assistente de marcações no Google Chat',
    assistantChatText: 'Marque, consulte, altere ou cancele marcações, suas ou dos seus colaboradores, escrevendo ao assistente no Google Chat.',
    assistantChatSpamHint: 'Na primeira vez, o Google avisará que o convite pode ser spam. É normal: clique em «Aceitar mesmo assim» (Accept anyway).',
    assistantChatPreparing: 'A preparar o seu chat…',
    assistantChatError: 'Não foi possível abrir o chat. Tente novamente dentro de alguns minutos.',
    assistantChatRetry: 'Tentar novamente',
    assistantChatOpen: 'Abrir o Google Chat',
    reservedSlot: 'Reservada',
    releaseSlotTitle: 'Liberar o horário de {date} às {time}?',
    releaseSlotText: 'O horário voltará a estar disponível para marcação. As alterações de disponibilidade não guardadas serão perdidas.',
    releaseSlotActiveBookings: 'Atenção: ainda há {count} marcação(ões) neste horário ({names}). Se o libertar, poderá ser marcado novamente.',
    releaseSlotBtn: 'Libertar',
    slotReleased: 'Horário libertado',
    releaseSlotError: 'Não foi possível libertar o horário',
    selectDaySeeAvailability: 'Selecione um dia para ver a disponibilidade',
    ready: 'Pronto',
    bookingsHistory: 'Histórico de consultas',
    downloadPDF: 'Baixar em PDF',
    selectCompanySeeResult: 'Selecione uma companhia para ver os resultados',
    noAvailableResults: 'Sem resultados disponíveis',
    statisticsWelcome: 'Bem-vindo ao assistente de estatísticas',
    statisticsHelp:
      'Digite sua consulta no chat para começar a visualizar os dados. Você pode perguntar sobre sessões, tempo, armazéns, áreas afetadas e muito mais.',
    statiticsExamplesTitle: 'Exemplos de perguntas:',
    statiticsExamples1: 'Armazéns ordenados por consultas realizadas nos últimos 6 meses',
    statiticsExamples2: 'Os 3 setores com mais consultas de cada armazém este ano',
    statiticsExamples3: 'Armazéns com mais faltas de comparecimento',
    statiticsExamples4: 'Gráfico da evolução de consultas por mês',
    statiticsExamples5: 'Qual é a zona corporal mais tratada?',
    statiticsTitle: 'Assistente de Estatísticas por IA',
    statiticsSubTitle: 'Estatísticas em tempo real',
    statiticsCharts: 'Gráficos',
    statiticsData: 'Dados da Consulta'
  }
}
